// extracted by css-extract-rspack-plugin
export default {"formStepsWrapper":"_ce43e4ea","headerWrapper":"_f2adbb22","divider":"_1c9bf64f","formError":"_df71140"};